exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spinner-and-text-wrapper {\n    display: flex;\n    flex-direction: column;\n    height: 20rem;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 10rem;\n}\n\n.spinner-and-text-wrapper p {\n    font-size: 2rem;\n}\n\n.outer-spinner-and-text-wrapper {\n    height: 100%;\n}", ""]);

// exports
